import App from './filesystem/Filesystem.svelte';

const app = new App({
	target: document.body,
	props: {}
});

export default app;
